export default __webpack_public_path__ + "static/media/home-restaurant-img-02.1fb55245.png";